export default __webpack_public_path__ + "static/media/audio_53_licuadora.064c6682.mp3";